import gql from "graphql-tag";

export const CAMPAIGNS_QUERY = gql`
query Campaign {
  campaigns(pagination: {limit: -1}) {
    data {
      id
      attributes {
        identifier
        title
        content
        priority
        startDate
        endDate
        product {
          data {
            attributes {
              name
              identifier
            }
          }
        }
        environments {
          data {
            attributes {
              label
              identifier
            }
          }
        }
        conditional
      }
    }
  }
}
`;

export type Campaign = {
    id: string;
    attributes: {
        identifier: string;
        priority: string;
        startDate: string;
        endDate: string;
        title: string;
        content: string;
        product: {
          data: {
            attributes: {
              name: string;
              identifier: string;
            }
          }
        };
        environments: {
          data: {
            attributes: {
              label: string;
              identifier: string;
            }
          }[],
        };
        conditional: any;
    }
  }